export interface Testimonial {
  initials: string
  name: string
  location: string
  quote: string
}

export interface Tomo {
  emoji: string
  title: string
  description: string
}

export interface Bono {
  number: string
  title: string
  description: string
  price: string
}

export interface ComparisonRow {
  situation: string
  without: string
  with: string
}

export interface CostRow {
  without: string
  cost: string
}

export interface Faq {
  question: string
  answer: string
}

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    quote:
      'Por primera vez no abandoné en la segunda semana. Tener el menú y la lista ya hechos me cambió todo.',
  },
  {
    initials: 'RM',
    name: 'Romina M.',
    location: 'Buenos Aires',
    quote:
      'Cocino una sola vez y comemos todos. Se terminó hacer dos comidas distintas.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    quote:
      'La lista de compras semanal me ahorró plata y me sacó el delivery de encima.',
  },
]

export const finalTestimonials: Testimonial[] = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    quote:
      'Bajé 9 kilos en cuatro meses sin pasar hambre. Todo del súper de siempre.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    quote:
      'Fue el primer julio que no me caí del plan. Los platos de invierno son únicos.',
  },
  {
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Rosario',
    quote: 'Keto Social me salvó en los asados. Sigo firme al otro día.',
  },
  {
    initials: 'NC',
    name: 'Natalia C.',
    location: 'Tucumán',
    quote:
      'Lo mejor no fue la balanza: fue la energía. Ya no tengo el bajón de las 4 de la tarde.',
  },
]

export const painPoints: string[] = [
  'Para el jueves ya abandonaste',
  'No sabés qué comer y terminás pidiendo delivery',
  'Cocinás dos veces: una para vos y otra para tu familia',
  'Recetas con ingredientes que no se consiguen acá',
  'La balanza se frena y no sabés qué hacer',
  'El mismo lunes, otra vez desde cero',
]

export const tomos: Tomo[] = [
  {
    emoji: '🦋',
    title: 'Tomo 1 — El Despegue',
    description:
      'Primeros 60 días: cetosis, despensa y menús desde el día uno.',
  },
  {
    emoji: '🥑',
    title: 'Tomo 2 — Hábito Consolidado',
    description:
      'El keto se vuelve rutina: desayunos rápidos, viandas y comer afuera.',
  },
  {
    emoji: '🌿',
    title: 'Tomo 3 — El Ecuador del Año',
    description: 'Más variedad para no aburrirte y seguir bajando.',
  },
  {
    emoji: '🔥',
    title: 'Tomo 4 — Resistencia y Variedad',
    description: 'Recetas nuevas y platos de temporada para sostener el plan.',
  },
  {
    emoji: '⚡',
    title: 'Tomo 5 — Turbo Resultados',
    description: 'Menús más estrictos y control real de antojos.',
  },
  {
    emoji: '💜',
    title: 'Tomo 6 — Estilo de Vida Permanente',
    description: 'Mantenimiento, fiestas, viajes y plan para el año que viene.',
  },
]

export const tomoIncludes: string[] = [
  '60 días de menús planificados',
  'Receta express, familiar y económica',
  'Lista de compras semanal del súper argentino',
  'Macros ya calculados — no hacés ninguna cuenta',
  'Reemplazos para lo que no conseguís o no te gusta',
  'Todo pensado para la realidad argentina',
]

export const bonos: Bono[] = [
  {
    number: '01',
    title: 'Mapa de Reemplazos Keto Argentina',
    description:
      'Cambiá cualquier ingrediente por uno que sí conseguís en tu barrio.',
    price: '$8.000',
  },
  {
    number: '02',
    title: 'Lista de Compras Keto Inteligente',
    description: 'Vas al súper una vez por semana y volvés con todo resuelto.',
    price: '$10.000',
  },
  {
    number: '03',
    title: 'Cocina Express Keto 10 Minutos',
    description: 'Platos completos para los días en los que no tenés tiempo.',
    price: '$9.000',
  },
  {
    number: '04',
    title: 'Batch Cooking Keto Dominical',
    description: 'Dos horas de domingo y toda la semana lista en la heladera.',
    price: '$8.000',
  },
  {
    number: '05',
    title: 'Keto Social Argentina',
    description: 'Asados, cumpleaños y salidas sin caerte del plan.',
    price: '$9.000',
  },
  {
    number: '06',
    title: 'Tracker Keto 365',
    description: 'Registrá tu progreso real y sostené la motivación todo el año.',
    price: '$9.000',
  },
]

export const turboRows: ComparisonRow[] = [
  {
    situation: 'La balanza se estanca',
    without: 'Te frustrás y esperás',
    with: 'Protocolo de desbloqueo en 7 días',
  },
  {
    situation: 'Querés acelerar',
    without: 'Comés menos y tenés hambre',
    with: 'Ayuno guiado paso a paso',
  },
  {
    situation: 'Volvés de vacaciones',
    without: 'Empezás de cero',
    with: 'Plan de reinicio de 72 horas',
  },
  {
    situation: 'No sabés si estás en cetosis',
    without: 'Adivinás',
    with: 'Checklist claro y simple',
  },
]

export const costRows: CostRow[] = [
  {
    without: 'Dieta nueva cada 3 meses',
    cost: 'Un año más que termina igual',
  },
  {
    without: 'Delivery sin plan',
    cost: 'Miles de pesos extra por mes',
  },
  {
    without: 'Suplementos “keto” caros',
    cost: 'Plata que no mueve la aguja',
  },
  {
    without: 'Cocinar dos veces',
    cost: 'El doble de tiempo, todos los días',
  },
]

export const faqs: Faq[] = [
  {
    question: '¿Sirve si nunca hice keto?',
    answer:
      'Sí. El Tomo 1 arranca desde cero: cetosis, despensa y menús desde el día uno. No necesitás saber nada previo.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Por email, en menos de 5 minutos. Descargás todo en PDF y lo usás desde el celular, la compu o impreso.',
  },
  {
    question: '¿Necesito ingredientes caros o importados?',
    answer:
      'No. Todo es del súper argentino. El Bono 1 resuelve cualquier reemplazo si algo no lo conseguís o no te gusta.',
  },
  {
    question: '¿Funciona si cocino para toda la familia?',
    answer:
      'Sí. Cada receta tiene versión familiar. Cocinás una sola vez y comen todos lo mismo.',
  },
]
